import React from "react";
import { Alert, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface LoadingProps {
  message: string;
  description: string;
}

export default function LoadingSpin({ message, description }: LoadingProps) {
  return (
    <div style={overlayStyle}>
      <div style={containerStyle}>
        <Spin
          size="large"
          tip={message}
          style={spinStyle}
          indicator={<LoadingOutlined spin />}
        >
          <div style={{ height: 50 }} /> {/* necessário para exibir o tip */}
        </Spin>
        <Alert
          message="Atenção"
          description={description}
          type="warning"
          showIcon
        />
      </div>
    </div>
  );
}

const overlayStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "50vh",
  backgroundColor: "rgba(240, 240, 240, 0.6)",
};

const containerStyle: React.CSSProperties = {
  maxWidth: 420,
  width: "90%",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: 24,
};

const spinStyle: React.CSSProperties = {
  marginBottom: 8,
};

const alertStyle: React.CSSProperties = {
  padding: 20,
  borderRadius: 12,
  backgroundColor: "#fff",
  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
};
